"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeValues = void 0;
var ThemeValues;
(function (ThemeValues) {
    ThemeValues["CLOSE_BUTTON_COLOR"] = "--close-button-color";
    ThemeValues["ARROW_BACKGROUND_COLOR"] = "--arrow-background-color";
    ThemeValues["ARROW_ICON_COLOR"] = "--arrow-icon-color";
    ThemeValues["BACKGROUND_COLOR"] = "--background-color";
    ThemeValues["SEND_BUTTON_BACKGROUND_COLOR"] = "--button-send-background-color";
    ThemeValues["SEND_BUTTON_FONT_COLOR"] = "--button-send-font-color";
    ThemeValues["PROGRESSBAR_COLOR"] = "--progressBar-color";
    ThemeValues["MODULE_TITLE_TEXT_COLOR"] = "--question-color";
    ThemeValues["RESPONSE_TEXT_COLOR"] = "--response-color";
    ThemeValues["SELECTED_RESPONSE_TEXT_COLOR"] = "--response-selected-color";
    ThemeValues["TEXT_FONT_FAMILY"] = "--font-family-text";
})(ThemeValues = exports.ThemeValues || (exports.ThemeValues = {}));
